<template>
  <div class="cont">
    <div :class="{ 'cont-title': true, none: !subtitle }">{{ title }}</div>
    <div class="cont-subtitle">{{ subtitle }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.cont {
  margin: 0 auto 20px;
  text-align: center;
  &-title {
    font-weight: 700;
    font-size: 20px;
    color: #151a23;
    line-height: 23px;
    padding-bottom: 6px;
    border-bottom: 1px solid #999999;
    margin-bottom: 2px;
    display: inline-block;
    text-align: center;
  }
  .none {
    border: none !important;
  }
  &-subtitle {
    font-weight: 400;
    font-size: 9px;
    color: #999999;
    opacity: 0.4;
    line-height: 11px;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
}
</style>
